/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Work_Order_Publish_Status_For_TrackInputs */



/**
* | output |
* | --- |
* | "Status for {name}" |
*
* @param {Work_Order_Publish_Status_For_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_for_track = /** @type {((inputs: Work_Order_Publish_Status_For_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_For_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Statut pour ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Status für ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Stato per ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Статус для ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Estado de ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.name} 的状态`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} のステータス`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} के लिए स्थिति`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Status para ${i?.name}`)
	return /** @type {LocalizedString} */ (`Status for ${i?.name}`)
});